{
  "name": "03 blob barrier",
  "title": "Barrier",
  "description": "BarrierDescription1",
  "stat": 48,
  "boughtEarlyStat": 50,
  "inventoryStat": 49,
  "lockFlag": 72
}